import {IconName} from '@vio/atlas/Icon'

import {PropertyHighlight} from './types'

// This list copies the Theme enum in FindHotel/highlights. A new theme appears there first.
const themeIcons: Record<string, IconName> = {
  location: 'Walk',
  wellness: 'SpaWellness',
  family: 'FamilyRoom',
  views: 'Sunrise',
  room_space: 'Room',
  food_dining: 'Restaurant',
  property_character: 'Sparkles',
  work_connectivity: 'Briefcase',
  sports_activities: 'Dumbell',
  parking: 'Parking',
  beach_access: 'Beach2',
  airport_links: 'PlaneTakeOff',
  experience: 'DoubleChatBubble'
}

// Override the theme icon, usually sports_activities, with the bike icon.
const bikeMention = /\bbi(ke|cycle)s?\b/i

export const getHighlightIcon = ({
  theme,
  concise
}: PropertyHighlight): IconName =>
  bikeMention.test(concise) ? 'Bicycle' : themeIcons[theme]

export const isSupportedTheme = ({theme}: PropertyHighlight) =>
  Object.hasOwn(themeIcons, theme)
